import React from "react";
import { motion } from "framer-motion";
import { WindIcon, HelpCircleIcon, BatteryLowIcon, XCircleIcon, CookieIcon, HeartCrackIcon, BoxIcon } from "lucide-react";
interface PainPoint {
  icon: BoxIcon;
  titulo: string;
  texto: string;
}
const painPoints: PainPoint[] = [{
  icon: WindIcon,
  titulo: 'Terminás de comer y sentís la panza hinchada',
  texto: 'Incluso cuando intentás cuidarte, la inflamación no desaparece'
}, {
  icon: HelpCircleIcon,
  titulo: 'No sabés qué cocinar saludable',
  texto: 'Se te agotan las ideas y terminás comiendo lo de siempre'
}, {
  icon: BatteryLowIcon,
  titulo: 'Falta de energía constante',
  texto: 'Te sentís agotada después de comer, imposible concentrarse'
}, {
  icon: XCircleIcon,
  titulo: 'La "dieta" no es sostenible',
  texto: 'Empezás motivada pero abandonás porque es muy restrictiva'
}, {
  icon: CookieIcon,
  titulo: 'Comés por ansiedad y estrés',
  texto: 'Sabés que no deberías pero la ansiedad es más fuerte'
}, {
  icon: HeartCrackIcon,
  titulo: 'Pérdida de confianza en tu cuerpo',
  texto: 'Has intentado tanto y nada funciona. Desististe de creer'
}];
export function PainPoints() {
  return <section className="w-full bg-white px-6 py-16 sm:px-10 lg:py-20" data-id="element-105" data-mp="1tzhiwmoe6k6z">
      <div className="mx-auto max-w-6xl" data-id="element-106" data-mp="27rp4rje50qqw">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-107" data-mp="23rdi6127sgcs">¿Te suena familiar?</h2>
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-14 lg:grid-cols-3" data-id="element-108" data-mp="1g1astspopohv">
          {painPoints.map((point, index) => <motion.div key={point.titulo} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col items-start rounded-xl border border-gray-200 bg-gray-100 p-7 transition-shadow duration-150 ease-out hover:shadow-md" data-id="element-109" data-mp="1b417ao5f1wzb" data-mpi={index}>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-mint/10 text-mint-dark" data-id="element-110" data-mp="1t4ddktflis43">
                <point.icon className="h-5 w-5" aria-hidden="true" data-id="element-111" data-mp="1y2oqxe53nkr2" />
              </span>
              <h3 className="mt-4 text-base font-semibold text-gray-800" data-id="element-112" data-mp="2274psvgaprws">{point.titulo}</h3>
              <p className="mt-2 text-sm text-gray-600" data-id="element-113" data-mp="273mvbxjg9ua6">{point.texto}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}